import { Bar, mixins } from "vue-chartjs"
// KEEP ChartAnnotation import otherwise plugin not auto-loaded
// eslint-disable-next-line
import * as ChartAnnotation from "chartjs-plugin-annotation"
import numeral from "numeral"

export default Bar.extend({
    mixins: [mixins.reactiveProp],
    props: {
        chartData: {
            type: Array | Object,
            required: false
        },
        annotations: {
            type: Array,
            default () {
                return []
            }
        },
        yMax: {
            type: Number,
            default: 0
        }
    },
    watch: {
        yMax: {
            handler (newOption, oldOption) {
                this._chart.destroy()
                this.renderChart(this.chartData, this.options)
            },
            deep: true
        },
        annotations: {
            handler (newOption, oldOption) {
                if(this._chart) this._chart.destroy()
                this.renderChart(this.chartData, this.options)
            },
            deep: true
        }
    },
    methods: {
        click (event) {
            try {
                const chart_element = this._chart.getElementAtEvent(event)[0]
                const dataset = this._chart.config.data.datasets[chart_element._datasetIndex]
                this.$emit("click", dataset.project.id, event)
            } catch (e) {}
        }
    },
    computed: {
        options () {
            return {
                onClick: this.click,
                tooltips: {
                    callbacks: {
                        title: (tooltipItems, data) => {
                            const lines = []
                            const project = data.datasets[tooltipItems[0].datasetIndex].project
                            if(project) {
                                if(project.number) {
                                    if(project.is_scoped) lines.push(`${project.number}.${project.number_suffix} ${project.name}`)
                                    else lines.push(`${project.number} ${project.name}`)
                                } else lines.push(project.name)
                                if(project.is_scoped) lines.push(`${project.nickname}`)
                            } else lines.push("Time Off")
                            // let lines = [label + " (" + tooltipItems[0].xLabel + ")"]
                            return lines
                        },
                        beforeBody: (tooltipItems, data) => {
                            const project = data.datasets[tooltipItems[0].datasetIndex].project
                            const lines = []
                            let pic_pm = []
                            if(project && !!project.pic_initials) pic_pm.push(project.pic_initials)
                            if(project && !!project.pm_initials) pic_pm.push(project.pm_initials)
                            if(project && !!project.d_initials) pic_pm = pic_pm.concat(project.d_initials)
                            if(pic_pm.length) lines.push(pic_pm.join(","))
                            lines.push("------------------")
                            return lines
                        },
                        label: function (tooltipItem, data) {
                            /*
                            let total_hours = 0
                            data.datasets.forEach((dataset, i) => {
                                total_hours += dataset.data[tooltipItem.index] || 0
                            })
                            */
                            const value = numeral(tooltipItem.yLabel)
                            let label = value.format("0,0.0") + "h"
                            if(data.datasets[tooltipItem.datasetIndex].report_user) label += ` (${data.datasets[tooltipItem.datasetIndex].report_user.initials})`
                            // if(total_hours) label += " / " + numeral(total_hours).format("0,0.0") + "h (" + numeral((value.value() / total_hours) * 100).format("0,0") + "%)"
                            return label
                        }
                    }
                },
                scales: {
                    yAxes: [{
                        stacked: true,
                        ticks: {
                            beginAtZero: true,
                            suggestedMax: this.yMax,
                            fontColor: "#00274F",
                            callback: function (value, index, values) {
                                return numeral(value).format("0,0") + "h"
                            }
                        },
                        gridLines: {
                            display: true,
                            color: "rgba(0, 39, 79, 0.1)"
                        }
                    }],
                    xAxes: [{
                        stacked: true,
                        gridLines: {
                            display: false,
                            color: "rgba(0, 39, 79, 0.1)"
                        },
                        categoryPercentage: 0.9,
                        barPercentage: 0.8
                    }]
                },
                legend: {
                    display: true,
                    position: "right",
                    labels: {
                        fontSize: 12,
                        // fontFamily: "'Helvetica Neue', Helvetica, Arial, 'sans-serif'",
                        fontStyle: "bold",
                        fontColor: "#00274F",
                        boxWidth: 14,
                        padding: 13
                    }
                },
                responsive: true,
                maintainAspectRatio: false,
                annotation: {
                    drawTime: "beforeDatasetsDraw",
                    annotations: this.annotations
                }
            }
        }
    },
    mounted () {
        this.renderChart(this.chartData, this.options)
    }
})
